export function setMetatags(title = null, description = null, image = null, type = null, pathname = null, updated_at = null) {
  if(title) {
    title = title+" | Dieet.Club";
    document.title = title;
    document.querySelector('meta[property="og:title"]').setAttribute("content", title);
  } else {
    let defaultTitle = "Gezond eten met Dieet.Club";
    document.title = defaultTitle;
    document.querySelector('meta[property="og:title"]').setAttribute("content", defaultTitle);
  }

  if(description) {
    let newDescription = description.substring(0,400);
    if(description.length > 400) newDescription = newDescription+"…";
    document.querySelector('meta[name="description"]').setAttribute("content", newDescription);
    document.querySelector('meta[property="og:description"]').setAttribute("content", newDescription);
  } else {
    let defaultDescription = "Geef jezelf een doel, en word ook iedere dag beter!";
    document.querySelector('meta[name="description"]').setAttribute("content", defaultDescription);
    document.querySelector('meta[property="og:description"]').setAttribute("content", defaultDescription);
  }

  if(image) {
    document.querySelector('meta[property="og:image"]').setAttribute("content", image);
  } else {
    document.querySelector('meta[property="og:image"]').setAttribute("content", "https://dieet.club/dieetclub-geef-jezelf-een-doel-card.jpg");
  }

  if(type) {
    document.querySelector('meta[property="og:type"]').setAttribute("content", type);
  } else {
    document.querySelector('meta[property="og:type"]').setAttribute("content", "website");
  }

  if(pathname) {
    document.querySelector('meta[property="og:url"]').setAttribute("content", "https://dieet.club"+pathname);
  } else {
    document.querySelector('meta[property="og:url"]').setAttribute("content", "https://dieet.club/");
  }

  // todo_whn: updated_at
}

// this is somewhat brute-force, removing all []-characters, and everything in between parentheses.
export function removeMarkdown(markdown_text) {
  markdown_text = markdown_text.replace(/\n/g, " ");
  markdown_text = markdown_text.replace(/\[/g, "");
  markdown_text = markdown_text.replace(/\]/g, "");
  markdown_text = markdown_text.replace(/#/g, "");
  let return_txt = "";

  let index = 0, crawl = true;
  while(crawl) {
    let snipp_start = markdown_text.indexOf("(", index);
    if(snipp_start < 0) {
      crawl = false;
      if(return_txt === "") return_txt = markdown_text;
    } else {
      let snipp_end = markdown_text.indexOf(")", snipp_start+1); // +1 = "("
      if(snipp_end < 0) crawl = false;
      return_txt += markdown_text.substring(index, snipp_start);
      index = snipp_end+1; // +1 = ")"
    }
  }
  return return_txt;
}



// WEBPACK FOOTER //
// ./src/modules/metatag_functions.js